import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from "@backstage/theme";

export const baseLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      text: {
        primary: "#0f265c"
      },
      primary: {
        main: "#0f265c",
        contrastText: "#fffbe5"
      },
      // secondary: {
      //   main: "#565a6e",
      // },
      // error: {
      //   main: "#8c4351",
      // },
      // warning: {
      //   main: "#8f5e15",
      // },
      // info: {
      //   main: "#34548a",
      // },
      // success: {
      //   main: "#485e30",
      // },
      background: {
        default: "#d5d6db",
        paper: "#FFFFFF",
      },
      // banner: {
      //   info: "#34548a",
      //   error: "#8c4351",
      //   text: "#343b58",
      //   link: "#565a6e",
      // },
      // errorBackground: "#8c4351",
      // warningBackground: "#8f5e15",
      // infoBackground: "#343b58",
      navigation: {
        background: "#f6f6f6",
        indicator: "#000000",
        color: "#0f265c",
        selectedColor: "#0f265c",
        submenu: {background: '#ffea80'},
        navItem: {hoverBackground : '#e7e9ee'}
      },
    },
  }),
  defaultPageTheme: "home",
  fontFamily: "Arial",
  /* below drives the header colors */
  pageTheme: {
    home:          genPageTheme({ colors: ['#0f265c'], shape: shapes.wave }),
    documentation: genPageTheme({ colors: ['#0f265c'], shape: shapes.round,     }),
    tool:          genPageTheme({ colors: ['#0f265c'], shape: shapes.round }),
    service:       genPageTheme({ colors: ['#0f265c'], shape: shapes.round,    }),
    website:       genPageTheme({ colors: ['#0f265c'], shape: shapes.round,    }),
    library:       genPageTheme({ colors: ['#0f265c'], shape: shapes.round,    }),
    other:         genPageTheme({ colors: ['#0f265c'], shape: shapes.round }),
    app:           genPageTheme({ colors: ['#0f265c'], shape: shapes.round }),
    apis:          genPageTheme({ colors: ['#0f265c'], shape: shapes.round }),
  },
});
